import React from "react";
import NavigationComponent from "../components/NavigationComponent";
import moment from "moment";
import RangeContainerComponent from "../readiness/RangeContainerComponent";
import { RPEList } from "./RPEList";
import GraphComponent from "../readiness/GraphComponent";
import { DATE_FORMATS } from "../../../../constants";
import { utcToDatePicker } from "../../../../utils/converters/dates-helper";
import { mapUtcToDatePicker } from "../../../../utils/daily-stats";
import get from "lodash/get";
import { AthleteLinks } from "../../../../parts/athlete-links";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { ReportsBackHandler } from "../components/ReportsBackHandler";
class SessionRPE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      dateFrom: null,
      dateTo: null,
      quickDisabled: false,
      rangeSelector: {
        type: "months",
        value: 6,
      }, // in Weeks format
      hoveredDate: "",
      dateFormattedData: [],
      sortedRecent: true,
    };

    this.updateState = this.updateState.bind(this);
    this.filterStatsbyDateRange = this.filterStatsbyDateRange.bind(this);
    this.filterAndSort = this.filterAndSort.bind(this);
    this.readyChartData = this.readyChartData.bind(this);
    this.projectDateAndRPEValues = this.projectDateAndRPEValues.bind(this);
    this.getLineArrays = this.getLineArrays.bind(this);
    this.updateHoveredStat = this.updateHoveredStat.bind(this);
    this.getDateFirstEntry = this.getDateFirstEntry.bind(this);
  }

  updateHoveredStat(date = "") {
    this.setState({ hoveredDate: date });
  }

  filterStatsbyDateRange(stats = []) {
    let { dateFrom, dateTo } = this.state;
    dateTo = dateTo
      ? moment(dateTo, DATE_FORMATS.DATE_PICKER_FORMAT)
      : moment(new Date());
    dateFrom = moment(dateFrom, DATE_FORMATS.DATE_PICKER_FORMAT);

    const filteredStats = stats.filter((stat) => {
      const utcDate = moment(stat.utcDate.toString(), DATE_FORMATS.UTC);
      return utcDate.isSameOrAfter(dateFrom) && utcDate.isSameOrBefore(dateTo);
    });

    return filteredStats;
  }

  filterUnsetRPE(stats = []) {
    return stats.filter((stat) => {
      return !!stat.sessionRPE;
    });
  }

  sortRecent(a, b) {
    return b.utcDate - a.utcDate;
  }
  sortOldest(a, b) {
    return a.utcDate - b.utcDate;
  }

  sortStatsByDate(stats = [], type = "recent") {
    if (type === "recent") return stats.sort(this.sortRecent);
    return stats.sort(this.sortOldest);
  }

  filterAndSort(stats, type = "recent") {
    let result = this.filterStatsbyDateRange(stats);
    result = this.filterUnsetRPE(result);
    result = this.sortStatsByDate(result, type);
    return result;
  }

  getLineArrays(length = []) {
    const values = [11, 6, 7, 8, 9, 10, 11];
    const arrays = values
      .map((val) => {
        const arr = [];
        for (let i = 0; i < length; i++) {
          arr.push(val);
        }
        // arr example value: [6, 6, ...]
        return arr;
      })
      .reverse();
    return arrays;
  }

  projectDateAndRPEValues(stats) {
    return stats
      .map((stat) => {
        return {
          meta: utcToDatePicker(stat.utcDate),
          value: stat.sessionRPE + 0.5,
        };
      })
      .reverse();
  }

  readyChartData(stats) {
    const rpeLine = this.projectDateAndRPEValues(stats);
    const referenceLines = this.getLineArrays(stats.length);
    referenceLines.push(rpeLine);
    return referenceLines;
  }

  getLabels(stats) {
    const labels = stats.map((stat) => {
      return moment(stat.utcDate, DATE_FORMATS.UTC).format(
        DATE_FORMATS.DATE_PICKER_FORMAT
      );
    });
    return labels;
  }

  getDateFirstEntry() {
    const dailyStats = this.context.locals.dailyStats;
    if (!!dailyStats && dailyStats.length > 0) {
      const firstEntry = dailyStats
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .find((stats) => stats.sessionRPE);
      return firstEntry.date;
    }
  }

  componentDidMount() {
    const { value, type } = this.state.rangeSelector;

    this.setState(
      {
        dateFrom: moment(new Date(), DATE_FORMATS.DATE_DAY_FORMAT)
          .subtract(value, type)
          .format(DATE_FORMATS.DATE_PICKER_FORMAT),
      },
      () => {
        const { locals } = this.context;
        const { dailyStats } = locals;
        const listData = this.filterAndSort(dailyStats);
        const dateFormattedData = mapUtcToDatePicker({
          stats: listData,
          fieldToConvert: "utcDate",
          newField: "date",
        });
        this.setState({ dateFormattedData });
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.dateFrom !== this.state.dateFrom ||
      prevState.dateTo !== this.state.dateTo
    ) {
      const updatedData = this.filterAndSort(this.context.locals.dailyStats);
      const dateFormattedData = mapUtcToDatePicker({
        stats: updatedData,
        fieldToConvert: "utcDate",
        newField: "date",
      });
      if (this.state.sortedRecent) {
        this.setState({
          dateFormattedData: dateFormattedData.sort(this.sortRecent),
        });
      } else {
        this.setState({
          dateFormattedData: dateFormattedData.sort(this.sortOldest),
        });
      }
    }
  }

  updateState(state) {
    this.setState(state);
  }

  render() {
    const { locals } = this.context;
    const {
      query,
      pathname,
      activeUser,
      activeUserToRequest,
      athlete,
      dailyStats,
    } = locals;

    const { dateTo, dateFrom, hoveredDate } = this.state;
    const listData = this.filterAndSort(dailyStats);
    const dateFormattedData = mapUtcToDatePicker({
      stats: listData,
      fieldToConvert: "utcDate",
      newField: "date",
    });

    const [chartData, labels] = [
      this.readyChartData(listData),
      this.getLabels(listData).reverse(),
    ];

    const ticks = [5, 6, 7, 8, 9, 10, 11];
    const colors = [
      "var(--white-sessionrpe-graph)",
      "#FF3852",
      "#FB8500",
      "#F7B600",
      "#28C841",
      "#04A1E1",
    ];

    // RPE List data
    const columnsData = [
      {
        name: "Date",
        columnClass: "",
        field: "date",
        itemClass: "",
      },
      {
        name: "RPE",
        columnClass: "",
        field: "sessionRPE",
        itemClass: "rpe",
      },
    ];

    const intensityMeasure =
      get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
        ? "RPE"
        : "RiR";
    const isRiR = intensityMeasure === "RiR";

    return (
      <main role="reports-wrapper">
        <div className="athlete-section-header only-show-mobile">
          <AthleteLinks
            athlete={athlete}
            pathName={pathname}
            classNames={"only-show-mobile"}
            query={query}
          />
          <div className="athlete-select dropdown-athlete">
            <div
              className="avatar"
              style={{
                backgroundImage: `url(${getAvatarUrl(locals?.athlete?._id)})`,
              }}
            />
            <AthleteSelect locals={locals} />
          </div>
        </div>
        <NavigationComponent
          query={query}
          text="Calendar Day View"
          pathName={pathname}
          intensityMeasure={intensityMeasure}
          isRiR={isRiR}
          classNames="mobile-hidden"
        />
        <article role="report-content">
          <h2 className="mobile-hidden">Session RPE</h2>
          <ReportsBackHandler title={"Session RPE"} locals={locals} />
          <RangeContainerComponent
            {...this.state}
            key={1}
            updateState={this.updateState}
            sortedRecent={this.state.sortedRecent}
            getDateFirstEntry={this.getDateFirstEntry}
            locals={locals}
          />

          {chartData.some((line) => line.length > 0) && (
            <GraphComponent
              dateTo={dateTo}
              dateFrom={dateFrom}
              series={chartData}
              labels={labels}
              chartName="RPE"
              displayLeyend={false}
              colors={colors}
              tooltipOffset={0.5}
              updateHoveredStat={this.updateHoveredStat}
              bodyClass={"rpe"}
              sectionClassNames={"session-rpe"}
              chartOptions={{
                showLine: true,
                ticks,
                axisY: {
                  low: 5,
                  high: 11,
                  labelOffset: {
                    y: -12,
                    x: 5,
                  },
                  onlyInteger: true,
                },
              }}
            />
          )}

          <section role="double-table">
            <RPEList
              dateFrom={this.state.dateFrom}
              dateTo={this.state.dateTo}
              list={this.state.dateFormattedData}
              columnsData={columnsData}
              highlightedElem={hoveredDate}
              sortedRecent={this.state.sortedRecent}
              updateState={this.updateState}
              sectionClassNames={"session-rpe"}
            />
          </section>
        </article>
      </main>
    );
  }
}

export default SessionRPE;
